//TODO extend after the backend does prepare the api

import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import { BackgroundStylesInterface } from 'common/types/background-interfaces'
import FileType from 'common/types/FileType'
import {
  AlignType,
  BorderType,
  ContentWidthEnum,
  PaddingType,
} from 'common/types/styleTypes'
import { DataFile } from './data-file-interface'

export interface WebsiteFontSettingsInterface {
  fontSize?: number
  mobileFontSize?: number
  fontFamily?: string
  mobileFontFamily?: string
  fontStyle?: string
  mobileFontStyle?: string
  fontWeight?: string
  mobileFontWeight?: string
  lineHeight?: number
  mobileLineHeight?: number
  letterSpacing?: number
  mobileLetterSpacing?: number
  textAlign?: AlignType
  mobileTextAlign?: AlignType
  fontFileId?: number
}

export interface WebsiteTypographySettingsStylesInterface
  extends WebsiteFontSettingsInterface {
  textColor?: string
  backgroundColor?: string
}

export interface WebsiteTypographySettingsInterface {
  heading?: WebsiteTypographySettingsStylesInterface
  paragraph?: WebsiteTypographySettingsStylesInterface
}

export enum WebsiteButtonStyleEnum {
  Filled = 'filled',
  Outlined = 'outlined',
}

export enum WebsiteLinkStyleEnum {
  Underline = 'underline',
  Color = 'color',
}
export interface WebsiteBoxStyleInterface {
  style: string
  padding: PaddingType
  border: Partial<BorderType>
  typography: WebsiteFontSettingsInterface
}

export interface WebsiteLayoutSettings {
  contentWidth: ContentWidthEnum
  layoutGrid: {
    rowsCount: number
    horizontalGap: number
    verticalGap: number
  }
}

export interface WebsiteFormFieldsSettings extends WebsiteBoxStyleInterface {
  colors?: {
    formFieldText: string
    formFieldBackground: string
    formFieldBorder: string
  }
}

export interface WebsiteButtonsInterface extends WebsiteBoxStyleInterface {
  colors: {
    buttonText: string
    buttonBackground: string
    hoveredButtonBackground: string
    pressedButtonBackground: string
  }
}

export interface WebsiteButtonsAndLinksInterface {
  primary?: Partial<WebsiteButtonsInterface>
  secondary?: Partial<WebsiteButtonsInterface>
  links?: WebsiteButtonsInterface
}

export enum ButtonTypeEnum {
  Primary = 'primary',
  Secondary = 'secondary',
}

export interface WebsiteStylesInterface {
  typography?: WebsiteTypographySettingsInterface
  buttonsAndLinks?: WebsiteButtonsAndLinksInterface
  formFields?: Partial<WebsiteFormFieldsSettings>
  layout?: WebsiteLayoutSettings
}

// website theme

export interface WebsiteBackgroundPictureInterface {
  file: null | DataFile
  fileId?: number | null
  background: BackgroundStylesInterface
}

export interface WebsiteThemeBackgroundInterface {
  pageBackgroundColor: string
  pageBackgroundPicture: WebsiteBackgroundPictureInterface
  // ------------------------------------------------------------
  // TODO: ask the backend to replace the containerBackgroundColor with contentBackgroundColor
  // https://app.shortcut.com/systeme/story/79986/change-theme-fields
  contentBackgroundColor: string
  containerBackgroundColor: string
  // ------------------------------------------------------------
  // ------------------------------------------------------------
  // TODO: ask the backend to remove this field
  // https://app.shortcut.com/systeme/story/79986/change-theme-fields
  sectionBackgroundColor?: string
  // ------------------------------------------------------------
  popupBackgroundColor: string
}

export interface WebsiteThemeHeaderAndFooterInterface {
  headerTextColor: string
  headerBackgroundColor: string
  headerBackgroundPicture: WebsiteBackgroundPictureInterface
  footerTextColor: string
  footerBackgroundColor: string
  footerBackgroundPicture: WebsiteBackgroundPictureInterface
  footerBorder: string
}

export interface WebsiteThemeTextInterface {
  headingTextColor: string
  headingBackgroundColor: string
  paragraphTextColor: string
  paragraphBackgroundColor: string
}

export interface WebsiteThemeButtonsInterface {
  primaryButtonTextColor: string
  primaryButtonBackgroundColor: string
  primaryHoveredButtonBackgroundColor: string
  primaryPressedButtonBackgroundColor: string
  primaryButtonBorderColor: string
  secondaryButtonTextColor: string
  secondaryButtonBackgroundColor: string
  secondaryHoveredButtonBackgroundColor: string
  secondaryPressedButtonBackgroundColor: string
  secondaryButtonBorderColor: string
  ghostButtonTextColor: string
  ghostHoveredButtonBackgroundColor: string
  ghostPressedButtonBackgroundColor: string
  ghostButtonBorderColor: string
}

export type PrimaryButtonTheme = Pick<
  WebsiteThemeButtonsInterface,
  | 'primaryButtonTextColor'
  | 'primaryButtonBackgroundColor'
  | 'primaryHoveredButtonBackgroundColor'
  | 'primaryPressedButtonBackgroundColor'
>

export type SecondaryButtonTheme = Pick<
  WebsiteThemeButtonsInterface,
  | 'secondaryButtonTextColor'
  | 'secondaryButtonBackgroundColor'
  | 'secondaryHoveredButtonBackgroundColor'
  | 'secondaryPressedButtonBackgroundColor'
>

export type GhostButtonTheme = Pick<
  WebsiteThemeButtonsInterface,
  | 'ghostButtonTextColor'
  | 'ghostHoveredButtonBackgroundColor'
  | 'ghostPressedButtonBackgroundColor'
>

export interface WebsiteThemeButtonsTypeInterface {
  primary: PrimaryButtonTheme
  secondary: SecondaryButtonTheme
  ghost: GhostButtonTheme
}

export interface WebsiteThemeLinksInterface {
  linkTextColor: string
  linkHoveredBackgroundColor: string
  linkPressedBackgroundColor: string
}

export interface WebsiteThemeFormFieldsInterface {
  formFieldBackgroundColor: string
  formFieldTextColor: string
  formFieldBorderColor: string
}

export interface WebsiteThemeMiscellaneousInterface {
  dividersColor: string
}

export interface WebsiteThemeInterface {
  id?: number | null
  isCommon: boolean
  name: string
  background: WebsiteThemeBackgroundInterface
  headerAndFooter: WebsiteThemeHeaderAndFooterInterface
  text: WebsiteThemeTextInterface
  buttons: WebsiteThemeButtonsInterface
  links: WebsiteThemeLinksInterface
  formFields: WebsiteThemeFormFieldsInterface
  miscellaneous: WebsiteThemeMiscellaneousInterface
}

// website theme for save

export interface WebsiteBackgroundPictureForSaveInterface
  extends Omit<WebsiteBackgroundPictureInterface, 'file' | 'fileId'> {
  fileId: number | null
}

export interface WebsiteThemeBackgroundForSaveInterface
  extends Omit<WebsiteThemeBackgroundInterface, 'pageBackgroundPicture'> {
  pageBackgroundPicture: WebsiteBackgroundPictureForSaveInterface
}

export interface WebsiteThemeHeaderAndFooterForSaveInterface
  extends Omit<
    WebsiteThemeHeaderAndFooterInterface,
    'headerBackgroundPicture' | 'footerBackgroundPicture'
  > {
  headerBackgroundPicture: WebsiteBackgroundPictureForSaveInterface
  footerBackgroundPicture: WebsiteBackgroundPictureForSaveInterface
}

export interface WebsiteThemeForSaveInterface
  extends Omit<
    WebsiteThemeInterface,
    'isCommon' | 'background' | 'headerAndFooter'
  > {
  background: WebsiteThemeBackgroundForSaveInterface
  headerAndFooter: WebsiteThemeHeaderAndFooterForSaveInterface
}

// website theme list

export interface WebsiteThemeListColorsInterface {
  primary: string
  secondary: string
  pageBackground: string
  containerBackground: string
}

export interface WebsiteThemeListInterface {
  id: number
  name: string
  isCommon: boolean
  colors: WebsiteThemeListColorsInterface
}

export interface WebsiteThemesResponseInterface {
  total: number
  offset: number
  items: WebsiteThemeListInterface[]
}

// website settings
export interface WebsitePageDataInterface {
  id: number
  name: string
  pageContentId: number
  locale: PageLocaleEnum
  layoutPageId: number
  website: WebsiteSettingsInterface
}

interface WebsiteUserDomain {
  id: number
  name: string
}

export interface WebsiteSettingsInterface {
  id: number
  name: string
  locale: PageLocaleEnum
  style: WebsiteStylesInterface
  theme: WebsiteThemeInterface
  userDomain: WebsiteUserDomain | null
  active: boolean
}

// website settings state

export interface WebsiteSettingsState {
  websiteStyles?: WebsiteStylesInterface
  websiteThemesList?: WebsiteThemeListInterface[]
  websiteTheme?: WebsiteThemeInterface
  websiteDraftTheme: WebsiteThemeInterface | null
  websiteId?: number
  websiteName?: string
  websiteDomain?: WebsiteUserDomain | null
  websiteActive?: boolean
  websiteLayoutPageId?: number
  websiteLocale?: PageLocaleEnum
  currentWebsiteLocale?: PageLocaleEnum // selected locale in the language switcher in the pages management sidebar
  websiteLocales: PageLocaleEnum[]
}

export enum WebsiteSettingsTypographyTypeEnum {
  Paragraph = 'paragraph',
  Heading = 'heading',
  PrimaryButton = 'primaryButton',
  SecondaryButton = 'secondaryButton',
  FormField = 'formField',
}

export type WebsiteButtonAndFormFieldTypes = Extract<
  WebsiteSettingsTypographyTypeEnum,
  'primaryButton' | 'secondaryButton' | 'formField'
>

export type WebsiteButtonTypes = Extract<
  WebsiteSettingsTypographyTypeEnum,
  'primaryButton' | 'secondaryButton'
>
